import { useDispatch } from 'react-redux';
import { showSnackbar } from '../Reducer/SnackbarReducer';

export default function useCheckDuplicate() {
  const dispatch = useDispatch();

  /**
   * 중복 체크 (단일/복합 키 지원, 라벨 표시, 건수 + 예시 1건)
   * @param {Array} rows 전체 데이터
   * @param {Array} changedRows 변경/추가된 데이터
   * @param {Array} keyArray [{field: 'EMPLOYEE_NO', name: '사번'}, ...]
   * @returns {boolean} 중복 없으면 true, 중복 있으면 false
   */
  const checkDuplicate = (rows, changedRows, keyArray) => {
    const generateKey = (item) =>
      keyArray.map((k) => item[k.field]?.toString().trim() || '').join('_');

    const rowKeys = new Set(rows.map(generateKey).filter((v) => v));
    const changedKeys = changedRows
      .filter((f) => f.newYn === 'Y')
      .map(generateKey)
      .filter((v) => v);

    const duplicates = changedKeys.filter((k) => rowKeys.has(k));

    if (duplicates.length > 0) {
      // 중복 1건 예시
      const example = duplicates[0];
      const exampleDisplay = keyArray
        .map((k, idx) => `${k.name}: '${example.split('_')[idx]}'`)
        .join(', ');

      dispatch(
        showSnackbar({
          message: `중복된 데이터가 있습니다: ${duplicates.length}건 (${exampleDisplay})`,
          type: 'warning',
        })
      );

      return false;
    }

    return true;
  };

  return { checkDuplicate };
}